import React from 'react';

import { LoginRegistrationContainer } from '@/components/LoginRegistrationContainer';
import { RegistrationForm } from '@/components/RegistrationForm/RegistrationForm';
import { useLoginUser } from '@/hooks/use-login-user';
import useMobile from '@/hooks/use-mobile';

import styles from './styles.module.scss';

export default function Page() {
	const { isMobile } = useMobile();

	const { loginUser } = useLoginUser({ redirectOnError: true, redirectOnSuccess: true });

	if (isMobile) {
		return (
			<div className={styles.mobileWrapper}>
				<RegistrationForm onSuccess={loginUser} />
			</div>
		);
	}

	return (
		<LoginRegistrationContainer>
			<RegistrationForm onSuccess={loginUser} />
		</LoginRegistrationContainer>
	);
}
